import { ALL_EVENTS_VIEW } from "@/features/events/common/routes/route-list.ts"
import AllEventsView from "@/features/events/common/views/all-events-view.tsx"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

export const commonEventRoutes = [
  {
    path: ALL_EVENTS_VIEW,
    element: <AllEventsView />,
  },
]

const DESKTOP_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: commonEventRoutes,
  },
]

const MOBILE_NO_MENU_LAYOUT_COMMON_EVENTS_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: commonEventRoutes,
  },
]

export const getCommonEventRoutes = (isDesktop: boolean) => {
  if (isDesktop) {
    return DESKTOP_ROUTES
  }
  return MOBILE_NO_MENU_LAYOUT_COMMON_EVENTS_ROUTES
}
